import {cn, cva} from 'platform/shared';

import {useComponentsTheme} from '../../hooks/useComponentsTheme';
import {PREVIEW_ALPHA} from './levelInputTokens';
import {PERCENT_SCALE} from './utils/resolveLevel';

interface LevelPreviewProps {
  $fraction: number;
}

const levelPreviewVariants = cva('absolute bottom-0 left-0 top-0');

export function LevelPreview(props: LevelPreviewProps) {
  const theme = useComponentsTheme();

  return (
    <div
      className={cn(levelPreviewVariants())}
      style={{
        width: `${props.$fraction * PERCENT_SCALE}%`,
        backgroundColor: `${theme.colors.palettes.blue[60][100]}${PREVIEW_ALPHA}`,
      }}
    />
  );
}
